<!--
*  TTTech nerve-management-system
*  Copyright(c) 2022. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->

<template>
  <v-container id="iiotEnvironmentVariableContainer" class="mt-5 mb-5">
    <v-form id="iiotEnvironmentVariableForm" ref="envVariableForm">
      <v-row v-for="(variable, index) in prop" :key="index">
        <v-col cols="5" class="pa-0">
          <v-row class="ma-0">
            <v-text-field
              :id="`iiotEnvironmentVariableEnvInput_${index}`"
              v-model="variable.env_variable"
              :label="$t('workloadVersion.envVariable')"
              validate-on-blur
              :rules="[rules.required, rules.pattern, rules.duplicate]"
              :disabled="isReleased"
              :maxlength="WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_NAME.MAX_LENGTH"
              :minlength="WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_NAME.MIN_LENGTH"
              @keydown.enter.prevent="triggerSubmit"
            />
          </v-row>
        </v-col>
        <v-row justify="center" class="pt-8">
          <span>:</span>
        </v-row>
        <v-col cols="5" class="pa-0">
          <v-text-field
            :id="`iiotEnvironmentVariableValueInput_${index}`"
            v-model="variable.container_value"
            :label="$t('workloadVersion.variableValue')"
            validate-on-blur
            :rules="[rules.required]"
            :disabled="isReleased"
            :maxlength="WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_VALUE.MAX_LENGTH"
            :minlength="WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_VALUE.MIN_LENGTH"
            @keydown.enter.prevent="triggerSubmit"
          />
        </v-col>
        <v-col cols="1" class="mt-4 pa-0 pl-3">
          <v-btn
            :id="`iiotEnvironmentVariableRemoveButton_${index}`"
            fab
            x-small
            dark
            class="primary-tttech-background-btn"
            :disabled="isReleased"
            @click="removeEnvironmentVariable(index)"
          >
            <v-icon dark> mdi-minus </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="isFormValid">
        <div class="mb-1 ml-1">
          <v-btn
            id="iiotEnvironmentVariableNewButton"
            fab
            x-small
            dark
            class="primary-tttech-background-btn"
            :disabled="isReleased"
            @click="addNewEnvironmentVariable()"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </div>
        <span class="mt-1 ml-3">
          {{ $t('workloadVersion.newEnvironmentVariable') }}
        </span>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import {
  VALIDATION_REGEX,
  WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_NAME,
  WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_VALUE,
} from '@/constants';

export default {
  props: {
    prop: {
      type: Array,
      default: () => [],
    },
    version: {
      type: Object,
      default: () => ({}),
    },
    isReleased: {
      type: Boolean,
    },
  },
  data: () => ({
    VALIDATION_REGEX,
    WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_NAME,
    WORKLOAD_VERSION_ENVIRONMENT_VARIABLE_VALUE,
    isFormValid: false,
  }),
  computed: {
    rules() {
      return {
        required: (value) => !!value || this.$t('workloadVersion.required'),
        pattern: (value) =>
          VALIDATION_REGEX.VARIABLE_MAPPING_INFORMATION.test(value) || this.$t('workloadVersion.envVariablePattern'),
        duplicate: (value) => {
          const found = this.prop.filter((element) => element.env_variable === value);
          if (found.length > 1) {
            return false || this.$t('workloadVersion.envVariablePattern');
          }
          return true;
        },
      };
    },
  },
  mounted() {
    this.isFormValid = this.validationForm();
  },
  updated() {
    this.isFormValid = this.validationForm();
  },
  methods: {
    addNewEnvironmentVariable() {
      this.$refs.envVariableForm.$el.dispatchEvent(new Event('input'));
      const obj = {
        env_variable: '',
        container_value: '',
      };
      this.prop.push(obj);
    },
    removeEnvironmentVariable(index) {
      this.prop.splice(index, 1);
      this.$refs.envVariableForm.$el.dispatchEvent(new Event('input'));
    },
    validationForm() {
      return this.$refs.envVariableForm ? this.$refs.envVariableForm.validate() : false;
    },
    triggerSubmit() {
      if (this.isFormValid) {
        this.$emit('submit-event');
      }
    },
  },
};
</script>
